import { render } from "./ProposalArgumentTextPlayer.vue?vue&type=template&id=1d06b5b2"
import script from "./ProposalArgumentTextPlayer.vue?vue&type=script&lang=js"
export * from "./ProposalArgumentTextPlayer.vue?vue&type=script&lang=js"

import "./ProposalArgumentTextPlayer.vue?vue&type=style&index=0&id=1d06b5b2&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__